import {
    ButtonBase,
    Card,
    CardContent,
    Checkbox, FormControlLabel,
    makeStyles,
    Typography
} from "@material-ui/core";
import clsx from "clsx";
import { useMemo } from "react";
import { AcnColorTheme } from "../../../assets/css/AcnColorTheme";
import { ProductCard } from "../../../common/productCard/ProductCard";
import {
    AccountInfoResponse
} from "../../../models/ResponseModel";
import { padGinUnit } from "../../../utils/DeviceManager";
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';

interface SelectAccountProps {
    accounts: AccountInfoResponse[];
    onSelect: (accountNo: string, checked: boolean) => void;
    onSelectAll: (isIndeterminate: boolean) => void;
}
export function SelectAccount(props: SelectAccountProps) {
    const { accounts, onSelect, onSelectAll } = props;
    const classes = useStyles();

    const handleOnSelect = (accountNo: string, checked: boolean) => {
        onSelect(accountNo, checked);
    };

    const isSelected = (accountNo: string): boolean => {
        const selected: AccountInfoResponse[] = accounts.filter((item) => {
            return item.accountNo === accountNo;
        });
        return selected.length === 1 && selected[0].registered;
    };

    const handleOnSelectAll = () => {
        onSelectAll(isIndeterminate);
    };

    //Display Loam: 5มม5555,   MOONBIKE080501
    const getDisplayedNumber = (account: AccountInfoResponse): string => {
        switch (account.productType) {
            case "INSI":
                return account.accountNo;
            case "REG1":
                return account.accountNo.slice(-4);
            default:
                return account.registrationNumber;
        }

        // if (account.productType === 'INSI') return account.accountNo;
        // return account.registrationNumber
    }

    const isSelectAll = useMemo(() => {
        if (accounts.every((acc) => acc.registered)) {
            return true;
        } else {
            return false;
        }
    }, [accounts]);

    const isIndeterminate = useMemo(() => {
        const hasSelectedAcc = accounts.some((acc) => acc.registered);
        return !isSelectAll && hasSelectedAcc;
    }, [isSelectAll, accounts]);

    function isDisable(current: boolean) {
        const onlySelect: AccountInfoResponse[] = accounts.filter(
            (item) => item.registered
        );
        // console.log("Account List: " + accounts.);
        return onlySelect.length >= 9 && !current;
    }

    return (
        <div className={classes.root}>
            <div className={classes.selectAllBtn}>
                {accounts.length > 9 ? (
                    <Typography style={{fontFamily: "Prompt-Light", fontSize: 16}}>คุณสามารถเลือกได้สูงสุด 9 บัญชี</Typography>
                ) : (
                    <FormControlLabel
                        control={
                            <Checkbox
                                aria-label="เลือกเพื่อเชื่อมต่อทุกบัญชี"
                                name="selectAll"
                                checked={isSelectAll}
                                indeterminate={isIndeterminate}
                                color="default"
                                className={classes.checkbox}
                                onClick={handleOnSelectAll}
                            />
                        }
                        label={<span style={{fontFamily: "Prompt-Light", fontSize: 16}}>เลือกเพื่อเชื่อมต่อทุกบัญชี</span>}
                    />
                )}
            </div>
            <div
                style={{
                    marginTop: padGinUnit(16),
                    paddingRight: "12px",
                    width: "100%",
                }}
            >
                {accounts.map((item: AccountInfoResponse) => {
                    return (
                        <div
                            key={"account-selecting-id-" + item.accountNo}
                            className={clsx(
                                classes.accountCardContainer,
                                classes.marginBottom
                            )}
                        >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        className={classes.checkbox}
                                        disabled={isDisable(item.registered)}                               
                                        checked={item.registered}
                                        value={item.registered}
                                        onChange={(event) => {
                                            handleOnSelect(item.accountNo, event.currentTarget.checked);
                                        }}
                                        name="เลือกบัญชี"
                                    />
                                }
                                label={""}
                                className={classes.zeroMarginRight}
                            />
                            <ButtonBase
                                className={classes.fullWidth}
                                onClick={() =>
                                    handleOnSelect(item.accountNo, !isSelected(item.accountNo))
                                }
                            >
                                <Card
                                    className={clsx(classes.accountCard, {
                                        [classes.selectedCard]: isSelected(item.accountNo),
                                    })}
                                >
                                    <CardContent className={classes.accountCardContainer}>
                                        <ProductCard accountName={item.accountTypeName} accountNo={getDisplayedNumber(item)} loanGroup={item.loanGroup} />
                                    </CardContent>
                                </Card>
                            </ButtonBase>
                        </div>
                    );
                })}
            </div>
            <div style={{ height: 100 }} />
        </div>
    );
}

const useStyles = makeStyles(
    {
        root: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: "flex-start"
        },
        accountCard: {
            height: window.innerHeight < 480 ? 72 : 78,
            borderRadius: 8,
            boxShadow: "0px 0px 0.75px rgba(0, 0, 0, 0.25);",
            width: "100%",
        },
        selectedCard: {
            border: "1px solid #B8BEFF",
            backgroundColor: "#F5F6FF",
        },
        accountCardContainer: {
            display: "flex",
            alignItems: "center",
            width: "100%",
        },
        marginBottom: {
            marginBottom: padGinUnit(16),
        },
        fullWidth: {
            width: "100%",
        },
        accountCardDetail: {
            flexDirection: "column",
            marginLeft: "8px",
        },
        selectAllBtn: {
            whiteSpace: "nowrap",
            marginTop: "35px",
        },
        checkbox: {
            color: "#B8BEFF",
            "&.Mui-checked, &.MuiCheckbox-indeterminate": {
                color: AcnColorTheme.darkBlue,
            },
        },
        zeroMarginRight: {
            marginRight: 0,
        },
    },
    { name: "SelectAccount" }
);
